export const solutionEqualHeight = function(container) {
	if (!container || window.innerWidth < 1024) return;
	const allSolutionsWrapper = container.querySelectorAll('.solutions__fixed-content');
	let maxElHeight = 0,
			elHeight;
			
	window.addEventListener('load', ()=> {
		[].slice.call(allSolutionsWrapper).forEach(el => {
			elHeight = el.offsetHeight;
			if (elHeight > maxElHeight) maxElHeight = elHeight;
		});

		[].slice.call(allSolutionsWrapper).forEach(el => {
			el.style.minHeight = maxElHeight + 'px';
		});
	});
}
